/**
 * Merge a right-pane drag reorder into the full column order.
 *
 * `rightPaneOrder` contains only the reordered right-pane (non-pinned, visible)
 * column IDs. Every other ID in `prevOrder` — the pinned column and any
 * hidden-but-known IDs — keeps its position; the right-pane slots are refilled in
 * the new order; any right-pane IDs not already in `prevOrder` are appended.
 *
 * Pure and idempotent.
 */
export function reconcileColumnOrder(
  prevOrder: string[],
  rightPaneOrder: string[]
): string[] {
  const rightSet = new Set(rightPaneOrder);
  const result: string[] = [];
  let i = 0;
  for (const id of prevOrder) {
    if (rightSet.has(id)) {
      result.push(rightPaneOrder[i]); // refill this right-pane slot in new-order sequence
      i += 1;
    } else {
      result.push(id); // pinned or hidden/unknown ID — keep in place
    }
  }
  const seen = new Set(result);
  for (const id of rightPaneOrder) {
    if (!seen.has(id)) {
      result.push(id);
    }
  }
  return result;
}
